"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shallowEqual = _interopRequireDefault(require("./utils/shallowEqual"));

var _series = _interopRequireDefault(require("./utils/series"));

var _whilst = _interopRequireDefault(require("./utils/whilst"));

var _throttle = _interopRequireDefault(require("./utils/throttle"));

var _uniqueId = _interopRequireDefault(require("./utils/uniqueId"));

var _innerSize = require("./utils/innerSize");

var _excluded = ["children", "text", "style", "min", "max", "mode", "forceWidth", "forceSingleModeWidth", "throttle", "autoResize", "onReady"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function assertElementFitsWidth(el, width) {
  // -1: temporary bugfix, will be refactored soon
  return el.scrollWidth - 1 <= width;
}

function assertElementFitsHeight(el, height) {
  // -1: temporary bugfix, will be refactored soon
  return el.scrollHeight - 1 <= height;
}

function noop() {}

var TextFit = /*#__PURE__*/function (_React$Component) {
  _inherits(TextFit, _React$Component);

  var _super = _createSuper(TextFit);

  function TextFit() {
    var _this;

    _classCallCheck(this, TextFit);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      fontSize: null,
      ready: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleWindowResize", function () {
      _this.process();
    });

    return _this;
  }

  _createClass(TextFit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoResize = this.props.autoResize;

      if (autoResize) {
        window.addEventListener("resize", this.handleWindowResize);
      } // for first run to calc font size when component mounts


      this.process();
    }
    /*
      This was in the original package (https://github.com/malte-wessel/react-textfit),
      but seemed to cause the most amount of issues after componnentWillReceiveProps was deprecated.
      So it has been commented out for now along with the other updates when this packages was pulled
      internal to DNAT.
       NOTE: This lifecycle method only seems useful on non-static text, so if you are
      more concerned about scaling text to it's container and updating that font size when the screen resizes,
      then this component should still work well for your use case, but if you are updating the text itself
      or other aspects of the text who's font size is calculated by this component, then
      more work probably needs to be done on this component to make it recieve new props
      and recalculate the font size of the contained text.
    */
    // componentDidUpdate(prevProps) {
    //   const { ready } = this.state;
    //   if (!ready) return;
    //   if (shallowEqual(this.props, prevProps)) return;
    //   console.warn("componentDidUpdate runs ...");
    //   this.handleWindowResize();
    // }

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var autoResize = this.props.autoResize;

      if (autoResize) {
        window.removeEventListener("resize", this.handleWindowResize);
      } // Setting a new pid will cancel all running processes


      this.pid = (0, _uniqueId["default"])();
    }
  }, {
    key: "process",
    value: function process() {
      var _this2 = this;

      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max,
          mode = _this$props.mode,
          forceSingleModeWidth = _this$props.forceSingleModeWidth,
          onReady = _this$props.onReady;
      var el = this._parent;
      var wrapper = this._child;
      var originalWidth = (0, _innerSize.innerWidth)(el);
      var originalHeight = (0, _innerSize.innerHeight)(el);

      if (originalHeight <= 0 || isNaN(originalHeight)) {
        console.warn("Can not process element without height. Make sure the element is displayed and has a static height.");
        return;
      }

      if (originalWidth <= 0 || isNaN(originalWidth)) {
        console.warn("Can not process element without width. Make sure the element is displayed and has a static width.");
        return;
      }

      var pid = (0, _uniqueId["default"])();
      this.pid = pid;

      var shouldCancelProcess = function shouldCancelProcess() {
        return pid !== _this2.pid;
      };

      var testPrimary = mode === "multi" ? function () {
        return assertElementFitsHeight(wrapper, originalHeight);
      } : function () {
        return assertElementFitsWidth(wrapper, originalWidth);
      };
      var testSecondary = mode === "multi" ? function () {
        return assertElementFitsWidth(wrapper, originalWidth);
      } : function () {
        return assertElementFitsHeight(wrapper, originalHeight);
      };
      var mid;
      var low = min;
      var high = max;
      this.setState({
        ready: false
      });
      (0, _series["default"])([// Step 1:
      // Binary search to fit the element's height (multi line) / width (single line)
      function (stepCallback) {
        (0, _whilst["default"])(function () {
          return low <= high;
        }, function (whilstCallback) {
          if (shouldCancelProcess()) return whilstCallback(true);
          mid = parseInt((low + high) / 2, 10);

          _this2.setState({
            fontSize: mid
          }, function () {
            if (shouldCancelProcess()) return whilstCallback(true);
            if (testPrimary()) low = mid + 1;else high = mid - 1;
            return whilstCallback();
          });
        }, stepCallback);
      }, // Step 2:
      // Binary search to fit the element's width (multi line) / height (single line)
      // If mode is single and forceSingleModeWidth is true, skip this step
      // in order to not fit the elements height and decrease the width
      function (stepCallback) {
        if (mode === "single" && forceSingleModeWidth) return stepCallback();
        if (testSecondary()) return stepCallback();
        low = min;
        high = mid;
        return (0, _whilst["default"])(function () {
          return low < high;
        }, function (whilstCallback) {
          if (shouldCancelProcess()) return whilstCallback(true);
          mid = parseInt((low + high) / 2, 10);

          _this2.setState({
            fontSize: mid
          }, function () {
            if (pid !== _this2.pid) return whilstCallback(true);
            if (testSecondary()) low = mid + 1;else high = mid - 1;
            return whilstCallback();
          });
        }, stepCallback);
      }, // Step 3
      // Limits
      function (stepCallback) {
        // We break the previous loop without updating mid for the final time,
        // so we do it here:
        mid = Math.min(low, high); // Ensure we hit the user-supplied limits

        mid = Math.max(mid, min);
        mid = Math.min(mid, max); // Sanity check:

        mid = Math.max(mid, 0);
        if (shouldCancelProcess()) return stepCallback(true);

        _this2.setState({
          fontSize: mid
          /*, ready: true*/

        }, stepCallback); // @NOTE ready: true was added here from original code

      }], function (err) {
        // err will be true, if another process was triggered
        if (err || shouldCancelProcess()) return;

        _this2.setState({
          ready: true
        }, function () {
          return onReady(mid);
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          text = _this$props2.text,
          style = _this$props2.style,
          min = _this$props2.min,
          max = _this$props2.max,
          mode = _this$props2.mode,
          forceWidth = _this$props2.forceWidth,
          forceSingleModeWidth = _this$props2.forceSingleModeWidth,
          throttle = _this$props2.throttle,
          autoResize = _this$props2.autoResize,
          onReady = _this$props2.onReady,
          props = _objectWithoutProperties(_this$props2, _excluded);

      var _this$state = this.state,
          fontSize = _this$state.fontSize,
          ready = _this$state.ready;

      var finalStyle = _objectSpread(_objectSpread({}, style), {}, {
        fontSize: fontSize
      });

      var wrapperStyle = {
        display: ready ? "block" : "inline-block"
      };
      if (mode === "single") wrapperStyle.whiteSpace = "nowrap";
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: function ref(c) {
          return _this3._parent = c;
        },
        style: finalStyle
      }, props), /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(c) {
          return _this3._child = c;
        },
        style: wrapperStyle
      }, text && typeof children === "function" ? ready ? children(text) : text : children));
    }
  }]);

  return TextFit;
}(_react["default"].Component);

exports["default"] = TextFit;

_defineProperty(TextFit, "propTypes", {
  children: _propTypes["default"].node,
  text: _propTypes["default"].string,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  mode: _propTypes["default"].oneOf(["single", "multi"]),
  forceSingleModeWidth: _propTypes["default"].bool,
  throttle: _propTypes["default"].number,
  onReady: _propTypes["default"].func
});

_defineProperty(TextFit, "defaultProps", {
  min: 1,
  max: 100,
  mode: "multi",
  forceSingleModeWidth: true,
  throttle: 50,
  autoResize: true,
  onReady: noop
});